/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSRV2RuleStateResponse
 */
export interface SSRV2RuleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleStateResponse
     */
    errorMessage?: string | null;
}

export function SSRV2RuleStateResponseFromJSON(json: any): SSRV2RuleStateResponse {
    return SSRV2RuleStateResponseFromJSONTyped(json, false);
}

export function SSRV2RuleStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function SSRV2RuleStateResponseToJSON(value?: SSRV2RuleStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


